import React, { useEffect, useState, useRef } from "react";
import {
  BetaForm as useBetaForm,
  FileUploaderBase,
  ButtonBase,
  PickerSelectSimple,
  TextInputBase,
} from "@reusejs/react";
import { createFile, getBidderByUuid, verifyKyc } from "services";
import Loader from "../../../layouts/Loader";

export default function DocumentVerificationForm(props: any) {
  const fileRef: any = useRef();
  const [bidder, setBidder] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [selectedBackFile, setSelectedbackFile] = useState<any>([]);
  const [frontUploadedFile, setFrontUploadedFile] = useState<any>(null);
  const [backUploadedFile, setBackUploadedFile] = useState<any>(null);
  const documentForm = useBetaForm({
    document_type: "",
    front: "",
    back: "",
    aadhaar: "",
  });
  const form_constraints = {
    document_type: {
      presence: {
        allowEmpty: false,
      },
    },
    front: {
      presence: {
        allowEmpty: false,
      },
    },
    back: {
      presence: {
        allowEmpty: false,
      },
    },
    aadhaar: {
      presence: function (value: any, attributes: any) {
        if (attributes.document_type.value === "aadhaar") {
          return { allowEmpty: false };
        }
        return false;
      },
      numericality: function (value: any, attributes: any) {
        if (attributes.document_type.value === "aadhaar") {
          return true;
        }
        return false;
      },
      length: function (value: any, attributes: any) {
        if (attributes.document_type.value === "aadhaar") {
          return {
            is: 12,
          };
        }
        return false;
      },
    },
  };

  useEffect(() => {
    documentForm.setValidationRules(form_constraints);
  }, []);

  useEffect(() => {
    if (props.data?.uuid) {
      console.log("check here");
      init(props.data.uuid);
    }
  }, [props.data]);

  const init = async (uuid: any) => {
    try {
      const data = await getBidderByUuid(uuid);
      setBidder(data);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const handleDocumentVerification = async () => {
    try {
      console.log("documentForm.validate()", documentForm);
      if (documentForm.validate()) {
        documentForm.startProcessing();
        let payload: any = {
          bidder_uuid: props.data?.uuid,
          document_type: documentForm.value.document_type.value,
          front: `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${documentForm.value.front}?fm=jpg`,
          back: `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${documentForm.value.back}?fm=jpg`,
        };

        if (documentForm.value.aadhaar) {
          payload["aadhaar"] = documentForm.value.aadhaar;
        }
        const data = await verifyKyc(payload);
        if (props.callback && data) {
          props.callback(data);
        }
        documentForm.finishProcessing();
      }
    } catch (error: any) {
      console.log("check error:", error);
      documentForm.finishProcessing();
      if (error.response.data) {
        if (error.response.data.message === "Upstream Down")
          documentForm.setErrors({ front: ["External API ERROR"] });
        else documentForm.setErrors({ front: [error.response.data.message] });
      }
    }
  };
  return (
    <div className="w-full mt-8 border-t pt-6">
      <div className="max-w-xs">
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              {
                label: "Aadhaar",
                value: "aadhaar",
              },
              {
                label: "Passport",
                value: "passport",
              },
              {
                label: "Driving License",
                value: "drivingLicence",
              },
              {
                label: "Voter ID",
                value: "voterid",
              },
            ];
          }}
          defaultString="Select Document"
          defaultSelected={
            documentForm.getField("document_type") !== ""
              ? [documentForm.getField("document_type")]
              : []
          }
          labelBaseProps={{
            label: "Upload Other Document*",
          }}
          onChange={(value: any) =>
            documentForm.setField("document_type", value)
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={false}
          error={
            documentForm?.errors?.get("document_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {documentForm?.errors?.get("document_type")[0]}
              </p>
            ) : null
          }
        />
      </div>
      <div className="max-w-2xl sm:flex sm:justify-between space-y-4 sm:space-y-0 my-6">
        <div className="">
          <label
            htmlFor="front"
            className="block text-sm font-medium text-gray-800 mb-4"
          >
            Front*
          </label>

          <FileUploaderBase
            ref={fileRef}
            multiple={false}
            accept={"*/*"}
            autoUpload={true}
            upload={async (uploadedFile) => {
              const data: any = await createFile(uploadedFile, {
                owner_identifier: props.data?.uuid,
                owner_service: "bidder-kyc",
              });
              setFrontUploadedFile(data);
              documentForm.setField("front", data.uuid);
            }}
            beforeUpload={(uploadedFiles) => {
              console.log("beforeUpload:beforeUpload:>", uploadedFiles);
            }}
            afterUpload={async (uploadedFiles) => {
              console.log("beforeUpload:afterUpload:>", uploadedFiles);
            }}
            openFileUploader={(triggerClickHandler) => (
              <div
                className="h-48 w-72 sm:w-80 cursor-pointer"
                onClick={async () => await triggerClickHandler()}
              >
                {selectedFile.length > 0 ? (
                  <img
                    className="h-full w-full rounded-md object-cover"
                    src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${frontUploadedFile?.uuid}?fm=jpg`}
                    // src={URL.createObjectURL(selectedFile[0].file)}
                  />
                ) : (
                  <label className="w-72 sm:w-80 h-full flex flex-col justify-center items-center px-4 py-6 bg-white text-gray-600 rounded-lg shadow-lg tracking-wide uppercase border hover:bg-blue-200 hover:border-blue-600 hover:text-blue-600">
                    <svg
                      className="w-8 h-8"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    </svg>
                    <span className="mt-2 text-base leading-normal">
                      Select a file
                    </span>
                  </label>
                )}
              </div>
            )}
            selectedFiles={(file) => {
              console.log("selected file:>", file);
              setSelectedFile(file);
            }}
          />
          <label
            htmlFor="front"
            className="block text-sm font-medium text-gray-500 mt-3"
          >
            Please upload the front image of your document.
          </label>
          {documentForm?.errors?.get("front") ? (
            <p className="mt-2 text-sm text-red-500">
              {documentForm?.errors?.get("front")[0]}
            </p>
          ) : // <p>Hello</p>
          null}
        </div>
        <div className="">
          <label
            htmlFor="back"
            className="block text-sm font-medium text-gray-800 mb-4"
          >
            Back*
          </label>

          <FileUploaderBase
            ref={fileRef}
            multiple={false}
            accept={"*/*"}
            autoUpload={true}
            upload={async (uploadedFile) => {
              const data: any = await createFile(uploadedFile, {
                owner_identifier: props.data?.uuid,
                owner_service: "bidder-kyc",
              });
              setBackUploadedFile(data);
              documentForm.setField("back", data.uuid);
            }}
            beforeUpload={(uploadedFiles) => {
              console.log("beforeUpload:>", uploadedFiles);
            }}
            afterUpload={async (uploadedFiles) => {
              console.log("afterUpload:>", uploadedFiles);
            }}
            openFileUploader={(triggerClickHandler) => (
              <div
                className="h-48 w-72 sm:w-80 cursor-pointer"
                onClick={async () => await triggerClickHandler()}
              >
                {selectedBackFile.length > 0 ? (
                  <img
                    className="h-full w-full rounded-md object-cover"
                    src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${backUploadedFile?.uuid}?fm=jpg`}
                    // src={URL.createObjectURL(selectedBackFile[0].file)}
                  />
                ) : (
                  <label className="w-72 sm:w-80 h-full flex flex-col justify-center items-center px-4 py-6 bg-white text-gray-600 rounded-lg shadow-lg tracking-wide uppercase border hover:bg-blue-200 hover:border-blue-600 hover:text-blue-600">
                    <svg
                      className="w-8 h-8"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    </svg>
                    <span className="mt-2 text-base leading-normal">
                      Select a file
                    </span>
                  </label>
                )}
              </div>
            )}
            selectedFiles={(file) => {
              console.log("selected file:>", file);
              setSelectedbackFile(file);
            }}
          />
          <label
            htmlFor="front"
            className="block text-sm font-medium text-gray-500 mt-3"
          >
            Please upload the back image of your document.
          </label>
          {documentForm?.errors?.get("back") ? (
            <p className="mt-2 text-sm text-red-500">
              {documentForm?.errors?.get("back")[0]}
            </p>
          ) : null}
        </div>
      </div>
      {documentForm.value.document_type.value === "aadhaar" && (
        <div className="max-w-xs mb-8">
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Aadhaar Number*",
            }}
            name={"aadhaar"}
            onChange={(val) => documentForm.setField("aadhaar", val)}
            placeholder={"Enter aadhaar number"}
            type={"text"}
            error={
              documentForm?.errors?.get("aadhaar") ? (
                <p className="mt-2 text-sm text-red-500">
                  {documentForm?.errors?.get("aadhaar")[0]}
                </p>
              ) : null
            }
            value={documentForm.getField("aadhaar")}
            htmlFor={"aadhaar"}
          />
        </div>
      )}
      <ButtonBase
        variant="primary"
        type="submit"
        label={"Verify"}
        onClick={() => handleDocumentVerification()}
        buttonBaseClasses={{
          font: "text-base font-medium",
          backgroundColor: "bg-blue-600 hover:bg-blue-700",
          textColor: "text-white",
          border: "any",
        }}
        busy={documentForm.busy}
        busyText={<Loader height="h-6" width="w-6" />}
      />
    </div>
  );
}
